export const checkDisbledInput = (status, name) =>{
    if(status == "DRAFT"){
        if(
            name == 'date' || name == 'hospitalName' || name == 'hospitalType' || name == 'sicknessName' || name == 'patientType' ||
            name == 'privateCase' || name == 'note' || name.includes("approvers") ||  name.includes("slipNo") ||
            name == 'btnPush' ||  name.includes("documentType") ||  name.includes("descriptionForm") || name == 'refDocument' ||
            name.includes('totalSlipWithdraw') ||  name.includes("totalPrice") || name == "slipNo" || name == 'numberSlip' || name == 'dateTable'
        ){
            // return false
            return true
        }else{
            return true
        }
    }else if(status == "MOREINFO"){
        if(
            name == 'date' || name == 'hospitalName' || name == 'hospitalType' || name == 'sicknessId' || name == 'patientType' || name == 'refDocument' ||
            name == 'privateCase' || name == 'note' || name == 'checkNameWithdraw' || name.includes("documentType") ||  name.includes("descriptionForm") ||
            name == 'descriptionMedicalCertificate' || name == 'hospitalBankAccountId' || name == 'treatmentStartDate' || name == 'isJuristic' || name == 'cashFlg' ||
            name.includes('totalSlipWithdraw') ||  name.includes("totalPrice") || name == "slipNo" || name == 'numberSlip' || name == 'dateTable'
        ){
            return false
        }else{
            return true
        }
    }else if(status == "canEdit"){
        // return false
        if(
            name == 'date' || name == 'hospitalName' || name == 'hospitalType' || name == 'sicknessId' || name == 'patientType' ||
            name == 'privateCase' || name == 'note' ||  name.includes("slipNo") ||  name == 'totalCurrentWithdraw'||
            name == 'btnPush' || name == 'checkNameWithdraw' || name == 'isJuristic' || name == "hospitalBankAccountId" ||
            name.includes('totalSlipWithdraw') ||  name.includes("totalPrice") || name == "slipNo" || name == 'numberSlip' || name == 'dateTable' ||
            name == 'descriptionMedicalCertificate' || name == 'treatmentStartDate' || name == 'treatmentEndDate' || name == 'refDocument' || name == 'cashFlg' 
        ){
            return false
        }else{
            return true
        }
    }else{
        return true
    }
}

export const checkStatus = (status) =>{
    if(status == 'APPROVE'){
        return "อนุมัติ"
    }else if(status == 'PENDING'){
      return "รออนุมัติ"
    }else if(status == 'REJECT'){
      return "ไม่อนุมัติ"
    }else if(status == 'MOREINFO'){
      return "ขอเอกสารเพิ่มเติม"
    }else if(status == 'RETURN'){
      return "ส่งคืน Maker"
    }else if(status == 'PAID'){
      return "รอโอนเงิน"
    }else if(status == 'SUCCESS'){
      return "ดำเนินการเสร็จสิ้น"
    }else if(status == 'FAILED'){
        return "โอนเงินไม่สำเร็จ (รอจ่ายเงินสด)"
    }else if(status == 'DRAFT'){
        return "แบบร่าง"
    }else if(status == 'EDIT'){
        return "แก้ไข"
    }else if(status == 'CANCEL'){
        return "คืนเงินให้คลัง"
    }else if(status == 'CASH'){
        return "จ่ายเงินสด"
    }else if(status == 'CREATE'){
        return "สร้างเอกสาร"
    }else if(status == 'CANCELDOC'){
        return "ยกเลิกเอกสาร"
    }else if(status == 'PAIDCASH'){
        return "รับเป็นเงินสด"
    }
}

export const setSummaryTotal = (dataTalbeUploads, checkMoney, hospitalDetailValue) =>{
    let totalMoney = 0;
    let summaryTotalTable = 0
    let returnData = [];
                            
    dataTalbeUploads.forEach(({ totalPrice }) => {
        if(totalPrice){
            if(isFinite(String(totalPrice))){
                totalMoney += parseFloat(totalPrice);
            }else{
                totalMoney += parseFloat(totalPrice.replace(/,/g, ""));
            }
        }
    });    

    // console.log('totalMoney',totalMoney)
    summaryTotalTable = totalMoney

    // console.log('summaryTotalTable',summaryTotalTable)

    // if(hospitalDetailValue == 'เอกชน'){
    //     if(checkMoney == 'ฉุกเฉินเร่งด่วน' || checkMoney == 'ฉุกเฉิน ไม่รุนแรง' ){
    //         console.log('totalMoney',totalMoney)
    //         if(totalMoney >= 8000){
    //             totalMoney = 8000
    //         }else{
    //             totalMoney = totalMoney
    //         }
    //     }
    // }

    returnData['totalMoney'] = totalMoney
    returnData['summaryTotalTable'] = summaryTotalTable

    return returnData
}

export const setSummarySlipWithdrawTotal = (dataTalbeUploads, checkMoney, hospitalDetailValue) =>{
    let totalMoney = 0;
    let summaryTotalTable = 0
    let returnData = [];
                            
    dataTalbeUploads.forEach(({ totalSlipWithdraw }) => {

        console.log('totalSlipWithdraw',totalSlipWithdraw)
        if(totalSlipWithdraw){
            if(isFinite(String(totalSlipWithdraw))){
                totalMoney += parseFloat(totalSlipWithdraw);
            }else{
                totalMoney += parseFloat(totalSlipWithdraw.replace(/,/g, ""));
            }
        }
    });    

    summaryTotalTable = totalMoney

    returnData['totalMoney'] = totalMoney
    returnData['summaryTotalTable'] = summaryTotalTable

    return returnData
}


export const checkUploadsFile = (dataSlipFile) =>{
    let dataReturn = []
    dataReturn['dataSlipFile'] = []
    dataReturn['checkModal'] = false
    if(dataSlipFile.length !== 0){
        dataSlipFile.map((valuesFile , keyValuesFile) =>{
            dataSlipFile[keyValuesFile].slipNo = valuesFile.slipNo.trim()
            dataSlipFile[keyValuesFile].numberSlip = valuesFile.numberSlip.trim()
            if(!valuesFile.file){
                // checkModal = true
                dataReturn['checkModal'] = true
            }
    
            dataReturn['dataSlipFile'].push(dataSlipFile)
    
        })
    }
  

    return dataReturn
}